export default "__VITE_ASSET__DGaTC7tg__"